import { Box, Typography } from '@mui/material'
import { BasePageContainerProps, BaseHeader } from './BasePageContainer'

export const MobilePageContainer = ({ children, title, subtitle, headerAction }: BasePageContainerProps) => {
    return (
        <Box
            sx={{
                width: '100%',
                maxWidth: '100vw',
                overflow: 'hidden',
                bgcolor: '#1a1a1a',
                minHeight: '100vh',
                color: 'white',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
            }}
        >
            {/* Mobile Header Bar */}
            <Box
                sx={{
                    width: '100%',
                    height: 64, // Height for the header bar
                    display: 'flex',
                    alignItems: 'center',
                    px: 2,
                    pl: 6, // Space for hamburger menu
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    bgcolor: '#1a1a1a',
                }}
            >
                <Typography variant="h6" fontWeight="bold" sx={{ color: 'rgba(255,255,255,0.8)' }}>
                    {title}
                </Typography>
            </Box>

            {/* Main Content */}
            <Box
                sx={{
                    p: 2,
                    width: '100%',
                    boxSizing: 'border-box',
                }}
            >
                {subtitle && (
                    <Typography sx={{ color: 'rgba(255,255,255,0.7)', mb: 4 }}>
                        {subtitle}
                    </Typography>
                )}
                {headerAction && (
                    <Box sx={{ mb: 4 }}>
                        {headerAction}
                    </Box>
                )}
                {children}
            </Box>
        </Box>
    )
}